module.exports = __webpack_public_path__ + "img/comparescore.445fb982.png";